require('./$.species')(Array);


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.array.species.js
 ** module id = 202
 ** module chunks = 0
 **/